import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { company, footerLinks } from "../mock";
import PreviewDownloadButton from "./PreviewDownloadButton";

export default function Footer() {
  return (
    <footer className="bg-[#2b2b2b] text-gray-300">
      <div className="mx-auto max-w-[1240px] px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Site Links */}
        <div>
          <h4 className="font-heading text-white text-2xl mb-6 tracking-wide">Site Links</h4>
          <ul className="space-y-3">
            {footerLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="text-sm text-gray-400 hover:text-[#4aa3e0] transition-colors duration-200"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-heading text-white text-2xl mb-6 tracking-wide">Contact Us</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={18} className="text-[#4aa3e0] mt-0.5 shrink-0" />
              <span className="text-gray-400">
                {company.address.line1}
                <br />
                {company.address.line2}
              </span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={18} className="text-[#4aa3e0] shrink-0" />
              <a href={`tel:${company.phoneRaw}`} className="text-gray-400 hover:text-[#4aa3e0] transition-colors">
                {company.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={18} className="text-[#4aa3e0] shrink-0" />
              <a href={`mailto:${company.email}`} className="text-gray-400 hover:text-[#4aa3e0] transition-colors">
                {company.email}
              </a>
            </li>
          </ul>
        </div>

        {/* Map */}
        <div>
          <h4 className="font-heading text-white text-2xl mb-6 tracking-wide">Find Us</h4>
          <div className="rounded overflow-hidden border border-white/10">
            <iframe
              title="Market Street Ventures location"
              src="https://www.google.com/maps?q=9595+Six+Pines+Dr+The+Woodlands+TX+77382&output=embed"
              width="100%"
              height="180"
              style={{ border: 0, filter: "grayscale(0.3)" }}
              loading="lazy"
            />
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1240px] px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <p className="font-heading uppercase tracking-[0.12em] text-sm text-white mb-1">
              Sharing an update?
            </p>
            <p className="text-xs text-gray-400">
              Download a live PDF preview of every page to send to your team.
            </p>
          </div>
          <PreviewDownloadButton variant="dark" />
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1240px] px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <p className="text-xs text-gray-500">The Woodlands, Texas</p>
        </div>
      </div>
    </footer>
  );
}
